import { UPDATE_BUSINESS_ENABLED } from '../actions';

export function businessChatEnabled(state = false, action) {
  switch (action.type) {
    case UPDATE_BUSINESS_ENABLED: {
      return action.enabled;
    }
    default:
      return state;
  }
}
